import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PerformanceDTO, PerformanceDTOModel } from 'src/app/models/performanceDTO';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { MapService } from 'src/app/services/map.service';
import { PointsService } from 'src/app/services/points.service';
import { TabsService } from 'src/app/services/tabsService';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'performance-calculation',
  templateUrl: './performance-calculation.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class PopupPerformanceCalculationComponent implements OnInit {
  readonly forbiddenCalculationSubstring = TabsService.SEPARATOR;
  constructor(public calculationControlService : CalculationsControlService,
    public mapService : MapService,
    public pointsController : PointsService,
    public bsModalRef : BsModalRef,
    public endpointService: EndpointsService
    ) {
    this.calculationControlService.performanceDTOModel = new PerformanceDTOModel();
    this.calculationControlService.performanceDTO = new PerformanceDTO();
  }

  ngOnInit(): void {
    this.calculationControlService.getPerformanceDefaultValues();
  }

  performanceCalculationDME(): void{
    this.calculationControlService.performanceCalculationDMEInitialization();
    this.bsModalRef.hide();
  }

  performanceCalculationVOR(): void{
    this.calculationControlService.performanceCalculationVORInitialization();
    this.bsModalRef.hide();
  }

  cancel():void{
    this.bsModalRef.hide();
  }

  changeSelection():void{
    this.calculationControlService.performanceDTOModel.isSingleLevel = !this.calculationControlService.performanceDTOModel.isSingleLevel;
    this.calculationControlService.getPerformanceDefaultValues();
  }

  changeSupressSelection():void{
    this.calculationControlService.performanceDTOModel.isSupressOverlappingPolygons = !this.calculationControlService.performanceDTOModel.isSupressOverlappingPolygons;
  }

  changeSimplifySelection():void{
    this.calculationControlService.performanceDTOModel.isSimplifyPolygons = !this.calculationControlService.performanceDTOModel.isSimplifyPolygons;
  }

  changeRedundanceSelection():void{
    this.calculationControlService.performanceDTOModel.isRedundancy = !this.calculationControlService.performanceDTOModel.isRedundancy;
  }

  changeSubtendedAngleSelection():void{
    this.calculationControlService.performanceDTOModel.isSubtendedAngles = !this.calculationControlService.performanceDTOModel.isSubtendedAngles;
  }

  changeNSESelection():void{
    this.calculationControlService.performanceDTOModel.isNSE = !this.calculationControlService.performanceDTOModel.isNSE;
  }

  changeAvailablePairsSelection():void{
    this.calculationControlService.performanceDTOModel.isAvailablePairs = !this.calculationControlService.performanceDTOModel.isAvailablePairs;
  }

  getDocAndAltitude(value: string): string[] {
    let stringList : string[] = [];
		if(value == null) {
			return stringList;
		}
		var re = /(?<=< |> )(.*?)(?=\[)/g;
    var m;

    do {
        m = re.exec(value);
        if (m) {
            stringList.push(m[1]);
        }
    } while (m);

		 if (stringList.length == 1) {
			 stringList.push("80000");
		 }
		return stringList;
  }

  getArincFomText(value : string) : string {
    switch(value){
      case 'TERMINAL_USE':
        return '0: DOC < 25[NM] - ALTITUDE < 12000[FT]';
        break;
      case 'LOW_ALTITUDE_USE':
        return '1: DOC < 40[NM] - ALTITUDE < 18000[FT]';
        break;
      case 'HIGH_ALTITUDE':
        return '2: DOC < 130[NM] - ALTITUDE < 60000[FT]';
        break;
      case 'EXTENDED_HIGH_ALTITUDE':
        return '3: DOC > 130[NM]';
        break;
      case 'NOT_INCLUDED':
        return '7: NOT INCLUDED';
        break;
      case 'OUT_OF_SERVICE':
        return '9: OUT OF SERVICE';
        break;
    }
    return '';
  }

    isUserAdmin(): boolean{
      return UtilsService.getIsAdminFromJwtToken(this.endpointService.getUserRolesToken());
    }
}
